import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualTaxinvoiceEditPageRoutingModule } from './manual-taxinvoice-edit-routing.module';

import { ManualTaxinvoiceEditPage } from './manual-taxinvoice-edit.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualTaxinvoiceEditPageRoutingModule
  ],
  declarations: [ManualTaxinvoiceEditPage],
  exports: [
    ManualTaxinvoiceEditPage
  ],
})
export class ManualTaxinvoiceEditPageModule {}
